import React from 'react';
import { Drawer, Theme, Hidden, DrawerProps } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';

interface Props extends DrawerProps {
  open?: boolean;
}

export const drawerWidth = 240;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    drawer: {
      backgroundColor: theme.palette.primary.main,
      width: drawerWidth,
    },
  }),
);

const MobileDrawer: React.FC<Props> = ({ open = false, onClose, children }) => {
  const classes = useStyles();
  return (
    <Hidden xsDown implementation="css">
      <Drawer
        variant="temporary"
        open={open}
        classes={{ paper: classes.drawer }}
        onClose={onClose}
      >
        {children}
      </Drawer>
    </Hidden>
  );
};

export default MobileDrawer;
